export class InspectionClipboard {
  sourceInspectionId: string;
  selectedItems: { id: string; name: string }[];
  sourceIsOffline: boolean;
  deleteSource: boolean;
}
